// extracted by mini-css-extract-plugin
module.exports = {"hero":"FAQ_hero__3Bz52","faqList":"FAQ_faqList__3H10S","heroDesc":"FAQ_heroDesc__3fzIc","plusIcon":"FAQ_plusIcon__48FgS","heroIllustration":"FAQ_heroIllustration__3D4IW"};